import { useEffect, useState } from 'react';

import { cfetch } from '@confluence/network';

import { type Suggestion } from '../types/RemoteObject.ts';

type SuggestionsResponse = {
	suggestions: Suggestion[];
};

export const useFetchSuggestions = (spaceKey?: string): Suggestion[] => {
	const [suggestions, setSuggestions] = useState<Suggestion[]>([]);

	useEffect(() => {
		if (!spaceKey) {
			return;
		}

		const fetchSuggestions = async () => {
			try {
				const response = await cfetch(
					`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions`,
					{ method: 'GET' },
				);

				const data: SuggestionsResponse = await response.json();
				if (data.suggestions && data.suggestions.length > 0) {
					setSuggestions(data.suggestions);
				}
			} catch {
				// Silently fail — card won't render if there are no suggestions
			}
		};

		void fetchSuggestions();
	}, [spaceKey]);

	return suggestions;
};
